module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%"
    }
  }, [(!['1010698', '1010699', '1010700', '3010130'].includes(_vm.orderDetail.servCataId)) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "数据信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.softType) + "\n        ")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130' && _vm.fileDataList.dataFaceImg) ? _c('div', [_c('baseTag', {
    attrs: {
      "label": "面像照"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pane-download",
    staticStyle: {
      "display": "inherit",
      "height": "200px"
    }
  }, _vm._l((_vm.fileDataList.dataFaceImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-image__preview"
    }, [_c('el-image', {
      staticStyle: {
        "max-width": "120px",
        "height": "auto",
        "float": "left",
        "margin": "10px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.fileDataList.dataFaceImg
      }
    })], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130' && _vm.fileDataList.dataMouth) ? _c('div', [_c('baseTag', {
    attrs: {
      "label": "口内照"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pane-download",
    staticStyle: {
      "display": "inherit",
      "height": "140px"
    }
  }, _vm._l((_vm.fileDataList.dataMouth), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-image__preview"
    }, [_c('el-image', {
      staticStyle: {
        "max-width": "120px",
        "height": "100px",
        "float": "left",
        "margin": "10px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.fileDataList.dataMouth
      }
    })], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130' && _vm.fileDataList.dataVideo) ? _c('div', [_c('baseTag', {
    attrs: {
      "label": "影像资料"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pane-download",
    staticStyle: {
      "display": "inherit",
      "height": "140px"
    }
  }, _vm._l((_vm.fileDataList.dataVideo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-image__preview"
    }, [_c('el-image', {
      staticStyle: {
        "max-width": "120px",
        "height": "100px",
        "float": "left",
        "margin": "10px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.fileDataList.dataVideo
      }
    })], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130') ? _c('detail-data', {
    attrs: {
      "label": "模型数据",
      "fileList": _vm.orderDetail.dataScan,
      "servOrderId": _vm.orderDetail.servOrderId,
      "isDown": _vm.isDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isScanData === '1') ? _c('detail-data', {
    attrs: {
      "label": "扫描数据",
      "fileList": _vm.orderDetail.dataScan,
      "servOrderId": _vm.orderDetail.servOrderId,
      "isDown": _vm.isDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isMouthData === '1') ? _c('detail-photo', {
    attrs: {
      "label": "口内照片",
      "srcList": _vm.orderDetail.dataMouth,
      "servOrderId": _vm.orderDetail.servOrderId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isCbctData === '1') ? _c('detail-data', {
    attrs: {
      "label": "CBCT数据",
      "fileList": _vm.orderDetail.dataCbct,
      "dataSheet": _vm.orderDetail.dataSheet,
      "servOrderId": _vm.orderDetail.servOrderId,
      "isDown": _vm.isDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.dataScanRod != '[]' && _vm.orderDetail.servCataId != '3010130') ? _c('detail-data', {
    attrs: {
      "label": ['4010110'].includes(_vm.orderDetail.servCataId) ? '精密配件数据库' : '扫描杆和替代体数据库',
      "fileList": _vm.orderDetail.dataScanRod,
      "servOrderId": _vm.orderDetail.servOrderId,
      "isDown": _vm.isDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '4010110' && _vm.orderDetail.servOrderRpd.dataAccessory != '[]' && _vm.orderDetail.servOrderRpd.enclosure) ? _c('detail-data', {
    attrs: {
      "label": "精密配件数据库",
      "fileList": _vm.orderDetail.servOrderRpd.dataAccessory,
      "servOrderId": _vm.orderDetail.servOrderId,
      "isDown": _vm.isDown
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("扫描仪品牌：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a838b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/detailDown.vue
// module id = 614
// module chunks = 0